import { Injectable } from '@angular/core';
import { ITS_JUST_ANGULAR } from '@angular/core/src/r3_symbols';

export interface answer {
  name: string;
  value: string;
}
export interface answerPoll {
    name: string;
    answers: Array<string>;
}

export interface fieldObj {
  field: answerPoll
}


@Injectable({
  providedIn: 'root'
})
export class SchemaService {
  mySchema:any;
  reResponse:Array<answer> = [];
  reResponsePoll:Array<fieldObj> = [];
  constructor() { }

  createSchema(fields) {
    this.mySchema = {};
    this.mySchema.$schema = "http://json-schema.org/draft-04/hyper-schema#";
    this.mySchema.type = "object";
    this.mySchema.properties = {}
    Object.keys(fields).forEach(key => {
      let value = fields[key];
      if (value.schema instanceof Object) {
        this.mySchema.properties[value.name] = value.schema;
      } else {
        this.mySchema.properties[value.name] = JSON.parse(value.schema);
      }
    });
    return this.mySchema;
  }

  reModel(data) {
    this.reResponse = [];
    Object.keys(data).forEach((key) => {
      let ansObj: answer = {
        name: '',
        value: ''
      };
      if (data[key] !== '') {
        if (Array.isArray(data[key])) {
          data[key].sort();
          ansObj.name = key;
          ansObj.value = data[key].toString();
        } else {
          ansObj.name = key;
          ansObj.value = data[key];
        }

      }
      this.reResponse.push(ansObj);
    })
    return this.reResponse;
  }
  reModelPoll(data) {
    this.reResponsePoll = [];
    Object.keys(data).forEach((key) => {
      let answer;
      if (Array.isArray(data[key])) {
        answer = data[key];
      } else {
        answer = [data[key].trim()];
      }

      if (answer && answer.length) {
        let fieldObject: fieldObj = {
          field: {
            name: key,
            answers: answer,
          }
        };
        this.reResponsePoll.push(fieldObject);
      }
    })
    return this.reResponsePoll;
  }


}
